import { Table } from "antd"
import { useSelector } from "react-redux"
import CustomButton from "../../../components/CustomButton"

const CompareForm2 = ({ setViewBlock }) => {
    const { compareObjectsForm2, isLoadingCompare } = useSelector(state => state.projectReducer)
    return <div className="compare__form__wrapper">
        <div className="compare__form__wrapper__header">

            <CustomButton
                onClick={() => setViewBlock("default")}
                type="grey"
            >
                Закрыть
            </CustomButton>
        </div>
        <Table
            dataSource={compareObjectsForm2}
            pagination={false}
            loading={isLoadingCompare}
            bordered
        >
            <Table.Column
                dataIndex="rePTMCode"
                title="Код ПТМ"
            />
            <Table.Column
                dataIndex="rePTMName"
                title="Наименование группы"
            />
            <Table.ColumnGroup
                title="руб."
            >
                <Table.Column
                    dataIndex="minCostR"
                    title="Минимальная"
                    width='12%'
                />
                <Table.Column
                    dataIndex="avrCostR"
                    title="Средняя"
                    width='12%'
                />
                <Table.Column
                    dataIndex="maxCostR"
                    title="Максимальная"
                    width='12%'
                />
            </Table.ColumnGroup>
            <Table.ColumnGroup
                title="%"
            >
                <Table.ColumnGroup
                    title="Удельный вес элемента с"
                >
                    <Table.Column
                        dataIndex="minCostP"
                        title="Минимальной стоимостью"
                        width='12%'
                    />
                    <Table.Column
                        dataIndex="avrCostP"
                        title="Средней стоимостью"
                        width='12%'
                    />
                    <Table.Column
                        dataIndex="maxCostP"
                        title="Максимальной стоимостью"
                        width='12%'
                    />
                </Table.ColumnGroup>
            </Table.ColumnGroup>
        </Table>
    </div>
}

export default CompareForm2
